<template>
    <div id="main" class="content">
        <div class="container">
            <article class="js-gallery post-1202 post type-post status-publish format-standard has-post-thumbnail hentry category-uncategorized tag-11 tag-22 tag-29">
                <section class="post_content">
                    <header class="post_header">
                        <h1 class="post_title">关于我</h1>
                    </header>
                    <div class="post-body js-gallery">
                        <p class="aboutme">
                            一个刚好搭上80末班车的屌丝程序猿，不（hun）堪（bu）忍（xia）受（qu）一线城市的节奏和压力，退居二线谋（hun）求（chi）发（deng）展（si），现居武汉。目前在不想上班和穷的矛盾中瑟瑟发抖，踽踽而行，不知道何时才能实现不上班还有钱拿的梦想！有活介绍可以加页底的微信，有介绍女朋友的。。。也来吧！
                        </p>
                    </div>
                </section>
            </article>
        </div>
        <svg id="upTriangleColor" width="100%" height="40" viewBox="0 0 100 102" preserveAspectRatio="none">
            <path d="M0 0 L50 100 L100 0 Z"></path>
        </svg>
    </div>
</template>

<script>
    export default {
        name: 'aboutme'
    }
</script>

<style scoped>
    .container {
        padding: 10px 0px;
    }
    .post {
        margin: 0 auto
    }
    .aboutme{
        text-indent:2em;
    }
</style>



// WEBPACK FOOTER //
// src/pages/aboutme.vue